export enum Version {
  V1 = 'V1', // 결과표 개발 이전 버전
  V2 = 'V2', // 결과표 개발 이후 버전
}

export type VersionType = keyof typeof Version;
